import script from "./SignUpInvitedPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignUpInvitedPage.vue?vue&type=script&lang=ts&setup=true"

import "./SignUpInvitedPage.vue?vue&type=style&index=0&id=89e845b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89e845b6"]])

export default __exports__